import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';
import ModalContent from './ModalContent';
import ModalOverlay from './ModalOverlay';
const ModalWrapper = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  inset: 0;
`;
const Modal = ({ backgroundColor, borderRadius, buttonClose, content, className, clickOutsideClose, disableOverlay, handleClose, glassBackground, isOpen, padding, size, }) => {
    const [showUnmountAnimation, setShowUnmountAnimation] = useState(false);
    const closeOnEscapeKeyDown = (e) => {
        if ((e.charCode || e.keyCode) === 27) {
            closeAnimation();
        }
    };
    useEffect(() => {
        document.body.addEventListener('keydown', closeOnEscapeKeyDown);
        return function cleanup() {
            document.body.removeEventListener('keydown', closeOnEscapeKeyDown);
        };
    }, []);
    const closeAnimation = () => {
        setShowUnmountAnimation(true);
        setTimeout(() => {
            setShowUnmountAnimation(false);
            handleClose && handleClose();
        }, 200);
    };
    if (!isOpen) {
        return null;
    }
    return (React.createElement(React.Fragment, null, createPortal(React.createElement(ModalWrapper, { className: className },
        React.createElement(ModalOverlay, { clickOutsideClose: clickOutsideClose, disableOverlay: disableOverlay, glassBackground: glassBackground, handleClose: closeAnimation, showUnmountAnimation: showUnmountAnimation }),
        React.createElement(ModalContent, { backgroundColor: backgroundColor, borderRadius: borderRadius, buttonClose: buttonClose, content: content, handleClose: closeAnimation, glassBackground: glassBackground, padding: padding, size: size, showUnmountAnimation: showUnmountAnimation })), document.body)));
};
export default Modal;
